import { get } from 'lodash'
import { required } from 'utils/validation'

const validate = values => {
  return {
    value: required(get(values, 'value'))
  }
}

export default validate
